import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() {
    // Inyectar el servicio de autenticación aquí cuando esté disponible
    // constructor(private authService: AuthService) {}
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Obtener el token desde currentUser
    const authToken = this.getAuthToken();
    // Obtener el idioma
    const language = this.getLanguage();
    // Obtener la fecha actual
    const currentDate = this.getCurrentDate();
    // Obtener la zona horaria
    const timeZone = this.getTimeZone();

    // Clonar la petición para añadir las cabeceras
    let modifiedReq = req.clone();

    // Añadir cabecera de autorización si hay token
    if (authToken) {
      modifiedReq = modifiedReq.clone({
        headers: modifiedReq.headers.set('Authorization', `Bearer ${authToken}`),
      });
    }

    // Añadir cabecera de idioma si está disponible
    if (language) {
      modifiedReq = modifiedReq.clone({
        headers: modifiedReq.headers.set('Language', language),
      });
    }

    // Añadir cabecera de fecha actual
    modifiedReq = modifiedReq.clone({
      headers: modifiedReq.headers.set('CurrentDate', currentDate),
    });

    // Añadir cabecera de zona horaria
    modifiedReq = modifiedReq.clone({
      headers: modifiedReq.headers.set('TimeZone', timeZone),
    });

    // Enviar la petición modificada al siguiente manejador
    return next.handle(modifiedReq);
  }

  private getAuthToken(): string | null {
    try {
      const currentUser = localStorage.getItem('currentUser');
      if (currentUser) {
        const user = JSON.parse(currentUser);
        return user.token || null;
      }
    } catch (error) {
      console.error('Error parsing currentUser from localStorage:', error);
    }
    return null;
  }

  private getLanguage(): string | null {
    return localStorage.getItem('language');
  }

  private getCurrentDate(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  private getTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}